module.exports = __webpack_public_path__ + "img/6.ce434437.jpg";